class AuditoriaTributariaNfeController extends AbstractController
  @$inject = ['$injector', '$scope', '$timeout', '$filter', 'ngTableParams', 'authService', 'pathService', 'timeService', 'api', 'gql', '$uibModal', 'nfeService', 'configItemService', 'extratoNfeIcmsService']

  constructor: ($injector, scope, @timeout, @filter, ngTableParams, @authService, pathService, timeService, @api, @gql, @modal, @nfeService, configItemService, @extratoNfeIcmsService) ->
    super($injector)

    @apply = (fn) => scope.$apply(fn)
    @consulta = false
    @filtro = {}
    @reauditar = false

    Mousetrap.unbind('up up e f');
    Mousetrap.bind('up up e f', =>
      @Alert.info("Modo auditor #{if @reauditar then 'desativado' else 'ativado'}.", 'Atenção!')
      @reauditar = !@reauditar
    )
    
    @usuario = {}
    @authService.getCurrentUser (user) =>
      @usuario = user

    @perPage = 50
    @currentPage = 1
    @loadingTracker = @promiseTracker()
        
    @contratoId = scope.tabData.contratoId

    @tableParams = new ngTableParams({
      page: 1
      count: 9999
      sorting:
        emissao: 'desc'
    }, {
      counts: []
      total: 1
      $scope: { $data: {} }
    })

    @channel = "nfes:#{scope.tabData.contratoId}"

    @loadingTracker.addPromise timeService.getList((retorno)=>
      atual = new Date(retorno.dataAtual)
      @filtro.emissaoInicial = (new Date(atual.getFullYear(), atual.getMonth(), 1))
      @filtro.emissaoFinal = atual
    )

    @loadingTracker.addPromise configItemService.getConfig(
      {identificador: 'data_limite_auditoria', resource: 'EficienciaFiscal_Configuracoes'},
      (dataLimite) => @dataLimite = new Date(dataLimite)
    )   

    scope.$watch(
      => @tableParams.sorting()
    , (newVal) =>
      @consultar()
    )

    scope.$watch(
      => @filtro
    , (filtro) =>
      filtro and @empresa and @consultar()
    , true)

  hasAcesso: (empresa) ->
    empresa.ferramentasDisponiveis.includes("auditoria-fiscal-digital-nfe")

  onSelectEmpresa: () ->
    @podeEmitirExtratoIcms = false
  
    @loadingTracker.addPromise(
      @api.get("/eficiencia-fiscal/extrato-nfe-icms?contrato=#{@empresa.id}&q=check-only")
          .then(=> @podeEmitirExtratoIcms = true)
          .catch(=> @podeEmitirExtratoIcms = false)
    )

  consultar: (page = {}) ->
    if(@form && @form.$valid)
      @consulta = @filtro.emissaoInicial? or @filtro.emissaoFinal? or @filtro.numero? or @filtro.emitente? or @filtro.chave?

      query =
        gql(["""
        query NfesEmissaoTerceiros($empresaId: Int!, $order: NfeOrder!, $filter: NfeFilter!, $after: String, $before: String) {
          empresa: filial(id: $empresaId) {
            id
            nfesPage(order: $order, filter: $filter, after: $after, before: $before, limit: #{@perPage}) {
              after
              before
              nfes: entries {
                ... on Nfe {
                  id
                  numero
                  chave
                  status
                  emissao
                  valor
                  valorFrete
                  valorFreteManual
                  fretePendente
                  emitente {
                    id
                    nome
                    cpfCnpj
                    municipio
                    uf
                  }
                }                  
              }
            }
          }
        }
        """])

      if @consulta
        if @filtro.chave
          @filtro.chave = @filtro.chave.replace(/\D/g, '')

        if @filtro.emitente
          @filtro.emitente = @filtro.emitente
            .replace(/(\d{3})\.(\d{3})\.(\d{3})-(\d{2})/g, "$1$2$3$4")
            .replace(/(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})-(\d{2})/g, "$1$2$3$4$5")

        filtro = angular.copy @filtro
        filtro.emissaoInicial = if filtro?.emissaoInicial 
          filtro.emissaoInicial.toISOString()
        filtro.emissaoFinal = if filtro?.emissaoFinal
          filtro.emissaoFinal.toISOString()

        if filtro.numero
          delete filtro.emissaoInicial
          delete filtro.emissaoFinal

        if filtro.tipo == 'transferencia'
          filtro.transferencia = true
          delete filtro.tipo

        if filtro.fretePendente
          filtro.fretePendente = filtro.fretePendente.toBool()

        filtro.tipoEmissao = 'TERCEIROS'
        filtro.possuiXml = true
        order = {}

        for own k, v of @tableParams.sorting()
          order.sortField = k.toUpperCase()
          order.sortOrder = v.toUpperCase()

        {after, before} = page
        variables = {empresaId: @empresa.id, order: order, filter: filtro, after, before}

        @loadingTracker.addPromise(
          @gql.query(query, variables)
            .then(({empresa: {nfesPage: {after, before, nfes}}}) =>
              @listOfNfes = nfes.map((nfe) =>
                nfe.emissao = new Date(nfe.emissao)
                nfe.bloquearEmissao = true if nfe.emissao.getTime() < @dataLimite.getTime()

                return nfe
              )
              
              @nextPage = after
              @previousPage = before
              @currentPage = if page.after then @currentPage + 1 else if page.before then @currentPage - 1 else 1

              if !page.after && !page.before
                @searchContext = new Date()

              @tableParams.reload()
            )
            .catch((error) => 
              console.error(error)
              @Alert.error('Ocorreu um erro ao buscar a lista de NF-e.', 'Erro!', false)
            )
        )

  openLink: (nfe, tipo) ->
    if (tipo == 'extrato-icms')
      url = "/api/eficiencia-fiscal/extrato-nfe-icms?nfe=#{nfe.id}&reauditar=#{@reauditar}&q=emitir"
    else
      url = "/api/eficiencia-fiscal/auditoria-tributaria-render/?nfe=#{nfe.id}&reauditar=#{@reauditar}&tipo=#{tipo}"

    @gerandoRelatorio = true

    cbk.download(url)
      .catch((resp) => 
        if resp.message == 'empresa_sem_parametrizacao' 
          if tipo == 'pis-cofins' then @configurarPisCofins() else @configurarIcms(tipo)
      )
      .finally(=> 
        @timeout(=>
          @gerandoRelatorio = false
        )
      )

    return true

  configurarIcms: (tipo) =>
    if tipo == 'extrato-icms'
      mensagem = 'A funcionalidade exige que a empresa possua parâmetros de ICMS vigentes para a data de emissão da NF-e. Deseja configurá-los agora?'
    else 
      mensagem = 'A funcionalidade exige que a empresa possua parâmetros de ICMS vigentes para a data atual. Deseja configurá-los agora?'
    
    Confirm.warning(
      'Parâmetros de ICMS ausentes',
      mensagem,
      {
        'Não': angular.noop,
        'Configurar': () => 
          @modal.open({
            component: 'configuracaoIcmsModal',
            size: 'lg',
            keyboard: 'static',
            resolve: {
                empresaId: () => @contratoId,
                filialId: () => @empresa.id
            }
          }).result.then(
            (result) => 
              if result
                @empresa.icms = result
          )
      }
    )
  
  configurarPisCofins: () => 
    Confirm.warning(
      'Parâmetros de PIS/COFINS ausentes',
      'A funcionalidade exige que a empresa possua parâmetros de PIS/COFINS vigentes para a data atual. Deseja configurá-los agora?',
      {
        'Não': angular.noop,
        'Configurar': () => 
          @modal.open({
            component: 'configuracaoPisCofinsModal',
            size: 'lg',
            keyboard: 'static',
            resolve: {
                empresaId: () => @contratoId,
                filialId: () => @empresa.id
            }
          }).result.then((result) => result && @empresa.pisCofins = result)
      }
    )

  informarFrete: (nfe) ->
    @modal.open({
      backdrop: 'static',
      component: 'nfeFreteManualModal',
      resolve: {
        nfe: nfe,
        channel: () => @channel
      }
    }).result.then((result) ->
      nfe.frete_pendente = false
      nfe.valor_frete = result.valorFreteManual
    )

  emitirDanfe: (nfe) ->
    query =
      gql(["""
      query DownloadNfeDa($empresaId: Int!, $filter: NfeFilter!) {
          empresa: filial(id: $empresaId) {
              id
              nfe(filter: $filter) {
                  danfe { token }
              }
          }
      }
      """])

    tab = cbk.initDownloadTab();
    
    @gql.query(query, {empresaId: @empresa.id, filter: {chave: nfe.chave}})
        .then(({empresa: {nfe: {danfe: {token}}}}) =>
          cbk.download("/api/resume-operation/#{token}", tab)
        )
        .catch(=> @Alert.error('Ocorreu um erro ao gerar o DANFE.', 'Erro!', false))
    

angular.module("eficienciaFiscalModule").controller('auditoriaTributariaNfeController', AuditoriaTributariaNfeController)
